/* Project Import will be here */
import { post, IRequest } from "./index";
import { IProfileParams, IRetailerAddrRequestParams, IDeleteAddrRequestParams } from "models/profileModels";
/* Project Import will be here */

export const postProfileApi = (data: IProfileParams) => {
  const request: IRequest = {
    subUrl: `/Login/DirectRegistration`,
    data
  };
  return post(request);
};

export const getProfileApi = () => {
  const request: IRequest = {
    subUrl: `/Login/RetailerProfile`
  };
  return post(request);
};

export const getProfileAddress = () => {
  const request: IRequest = {
    subUrl: `/Retailer/GetRetailerAddress`
  };
  return post(request);
}

/* Add new retailer address */
export const addOrEditRetailerAddressApi = (data: IRetailerAddrRequestParams) => {
  const request: IRequest = {
    subUrl: `/Retailer/AddRetailerAddress`,
    data
  };
  return post(request);
};

/* Delete existing retailer address */
export const deleteRetailerAddressApi = (data: IDeleteAddrRequestParams) => {
  const request: IRequest = {
    subUrl: `/Retailer/DeleteRetailerAddress`,
    data
  };
  return post(request);
};